export default "__VITE_ASSET__vv$d87tV__"